export var EventOrigin;
(function(EventOrigin) {
    EventOrigin["HomeFeed"] = "home-feed";
    EventOrigin["BrandPage"] = "brand-page";
    EventOrigin["OrdersPage"] = "orders-page";
    EventOrigin["MyBrandsPage"] = "my-brands-page";
    EventOrigin["MyBrandsUpdatesPage"] = "my-brands-updates-page";
    EventOrigin["Unknown"] = "unknown";
})(EventOrigin || (EventOrigin = {}));
export var InsightCardElement;
(function(InsightCardElement) {
    InsightCardElement["Brand"] = "brand";
    InsightCardElement["Product"] = "product";
    InsightCardElement["Overlay"] = "overlay";
})(InsightCardElement || (InsightCardElement = {}));
export var MuteAction;
(function(MuteAction) {
    MuteAction["Mute"] = "mute";
    MuteAction["Unmute"] = "unmute";
    MuteAction["Dismiss"] = "dismiss";
})(MuteAction || (MuteAction = {}));
export var OVERLAY_EVENT_TOKEN = "overlay";
